export default __webpack_public_path__ + "assets/images/ff37fc453bd732620b9e3001a49fab97.svg";